
<div class="header-toolbar">
  <h1 *ngIf="mode === 'edit' || mode === 'new'">{{ title }}</h1>
  <h1 *ngIf="mode === 'view'">{{ entity?.name }}</h1>
</div>


<form #form="ngForm" (ngSubmit)="save()" autocomplete="off" *ngIf="entity">

  <!-- Toolbar -->
  <div *ngIf="mode === 'edit' || mode === 'new'" class="main btn-toolbar">

    <a class="btn" (click)="importRecord()" title="Importer les données d'un enregistrement">
      <t-icon name="add"></t-icon>
      <span class="text">Importer</span>
    </a>

    &nbsp;
        
    <button class="btn" type="submit" [disabled]="!entity.valid || saving">
      <t-icon name="check"></t-icon>
      <span class="text">Enregistrer</span>
    </button>

    &nbsp;

    <a class="btn" (click)="cancel()">
      <t-icon name="close"></t-icon>
      <span class="text">Annuler</span>
    </a>

  </div>
  
  <div *ngIf="mode === 'view'" class="main btn-toolbar">
        
    <div class="btn-group">    
      <div class="content">
        
        <a class="btn" [routerLink]="['edit']">
          <t-icon name="mode_edit"></t-icon>
          <span class="text">Modifier</span>
        </a>
        <button class="btn" (click)="delete()">
          <t-icon name="delete"></t-icon>
          <span class="text">Supprimer</span>
        </button>

      </div>
    </div>

    <div class="btn-group">    
      <div class="content">
        
        <a class="btn" *ngIf="entity?.hasMovements" [routerLink]="['movements-ledger', entity.version]">
          <t-icon name="seal_check"></t-icon>
          <span class="text">Registre des mouvements</span>
        </a>

        <a class="btn" [routerLink]="['history']">
          <t-icon name="query_builder"></t-icon>
          <span class="text">Historique</span>
        </a>

      </div>
    </div>

  </div>
  <!-- /Toolbar -->

  <div class="grid" *ngIf="entity">

    <div class="column">

      <div *ngIf="mode === 'edit' || mode === 'new'" class="panel">
        <h2>Entité</h2>

        <sl-entity-form [entity]="entity"></sl-entity-form>

      </div>
      
      <sl-entity-infos *ngIf="mode === 'view'" [entity]="entity"></sl-entity-infos>

      <sl-entity-extra-fields-panel *ngIf="mode === 'view'" [entity]="entity"  [dossierModel]="dossierModel"></sl-entity-extra-fields-panel>

      <sl-entity-details *ngIf="mode === 'view'" [entity]="entity"></sl-entity-details>
      
    </div>
    
    <div class="column">
      
      <sl-entity-extra-fields-form *ngIf="mode === 'edit' || mode === 'new'" [entity]="entity"  [dossierModel]="dossierModel"></sl-entity-extra-fields-form>
      
      <sl-entity-movements *ngIf="mode === 'view' && entity.draftMovements.length > 0" [entity]="entity" [mode]="'draft'"></sl-entity-movements>

      <sl-entity-movements *ngIf="mode === 'view'" [entity]="entity" [canAdd]="true"></sl-entity-movements>

      <sl-entity-movements *ngIf="mode === 'view' && entity.deletedMovements.length > 0" [entity]="entity" [mode]="'deleted'"></sl-entity-movements>
      
      <sl-entity-shareholders *ngIf="mode === 'view'" [entity]="entity"></sl-entity-shareholders>
      
      <sl-entity-owned-shares *ngIf="mode === 'view'" [entity]="entity"></sl-entity-owned-shares>

      <sl-entity-attachments *ngIf="mode === 'view'" [entity]="entity"></sl-entity-attachments>
      
      <sl-authorization-list *ngIf="mode === 'view'" [entity]="entity" title="Comptes clients autorisés"></sl-authorization-list>
    </div>

  </div>
</form>